'use strict';

var _ = require('lodash');
var FareChangeGridDataProviderService = function FareChangeGridDataProviderService($q, dataRetrieverService, dataRetrieverConstantsService, heatMapService, SearchCriteriaRule, $filter, App, BenchmarkService, hepService) {
  var rmNumberFormat = $filter('rmNumberFormat');
  var runFrequency = hepService.getSimpleHepProperty('DYNAMIC_PRICING_RECOM_FREQUENCY');
  function retrieveData(snapshotDateData) {
    var preparedFilter = [new SearchCriteriaRule({
      operator: '=',
      leftOperand: snapshotDateData.markets,
      field: 'market'
    }), new SearchCriteriaRule({
      operator: '=',
      leftOperand: snapshotDateData.poses,
      field: 'marketPosCabin.pos'
    }), new SearchCriteriaRule({
      operator: '=',
      leftOperand: snapshotDateData.cabins,
      field: 'marketPosCabin.cabinCode'
    }), new SearchCriteriaRule({
      operator: '=',
      leftOperand: snapshotDateData.snapshotDate,
      field: 'optimizationDate'
    })];
    if (runFrequency > 1) {
      preparedFilter.push(new SearchCriteriaRule({
        operator: '=',
        leftOperand: snapshotDateData.runNumber,
        field: 'runNumber'
      }));
    }
    return dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.PRICING_SUMMARY_SCREEN, dataRetrieverConstantsService.PRICING_SUMMARY_FARE_CHANGE).retrieveData(dataRetrieverConstantsService.PRICING_SUMMARY_FARE_CHANGE, preparedFilter);
  }
  function filter(snapshotDateData, fareGridData) {
    return _.filter(fareGridData, function (data) {
      return snapshotDateData.markets.indexOf(data.market) > -1 && snapshotDateData.poses.indexOf(data.pos) > -1 && snapshotDateData.cabins.indexOf(data.cabin) > -1 && data.direction === snapshotDateData.direction;
    });
  }
  function aggregate(snapshotDate, aggregationMethod, filteredData) {
    var marketPosAggregations = _.transform(filteredData, function (accumulators, el) {
      var key = [el.market, el.pos].join('#');
      var rangeName = getRange(el.departureDateDay, snapshotDate, aggregationMethod);
      accumulators[key] = accumulators[key] || {
        market: el.market,
        pos: el.pos,
        cabins: [],
        direction: el.direction
      };
      accumulators[key].cabins.push(el.cabin);
      _.forEach(el.metrics, function (newMetricValue, metricName) {
        var currentValue = getAccumulatorValue(accumulators[key], rangeName, metricName);
        var newValue = currentValue + newMetricValue;
        setAccumularValue(accumulators[key], rangeName, metricName, newValue);
      });
      return accumulators;
    }, {});
    return _.values(marketPosAggregations);
  }
  function project(accumulators) {
    var metricName = heatMapService.getCurrentMetric();
    return _.map(accumulators, function (accumulator) {
      var totalEffFareChange = 0;
      var totalEffServices = 0;
      var row = {
        market: accumulator.market,
        pos: accumulator.pos,
        cabin: getLowestCabin(accumulator.cabins),
        direction: accumulator.direction
      };
      _.forEach(heatMapService.getCurrentRanges(), function (rangeName) {
        var fareChange = getAccumulatorValue(accumulator, rangeName, 'totalFareChange') || 0;
        var effServices = getAccumulatorValue(accumulator, rangeName, 'effServices') || 0;
        var value = calcValue(metricName, fareChange, effServices) || 0;
        totalEffFareChange += fareChange;
        totalEffServices += effServices;
        row[rangeName] = formatValue(metricName, value);
      });
      var totalValue = calcValue(metricName, totalEffFareChange, totalEffServices) || 0;
      row.total = formatValue(metricName, totalValue);
      row.effServices = formatValue(metricName, totalEffServices);
      return row;
    });
  }
  function calcValue(metricName, fareChange, effServices) {
    if (metricName === 'totalFareChange') {
      return fareChange;
    }
    if (metricName === 'avgFareChange') {
      return fareChange / effServices;
    }
    throw new Error('Not supported metricName' + metricName);
  }
  function formatValue(metricName, value) {
    var rounded = _.round(value, 2);
    return rmNumberFormat(rounded, 'NUMBER_NO_DECIMAL', true);
  }
  function getAccumulatorValue(accumulator, rangeName, metricName) {
    var metricPath = ['totals', rangeName, metricName];
    return _.get(accumulator, metricPath, 0);
  }
  function setAccumularValue(accumulator, rangeName, metricName, value) {
    var metricPath = ['totals', rangeName, metricName];
    _.set(accumulator, metricPath, value);
  }
  function getRange(departureDateDay, snapshotDate, aggregationMethod) {
    return aggregationMethod === 'byMonth' ? getRangeByMonth(departureDateDay, snapshotDate) : getRangeDTD(departureDateDay);
  }
  function getRangeDTD(departureDateDay) {
    var currentRanges = heatMapService.getCurrentRanges();
    var currentRange;
    _.forEach(currentRanges, function (range) {
      range = range.split('-');
      range = _.map(range, function (r) {
        return parseInt(r, 10);
      });
      if (departureDateDay >= range[0] && departureDateDay <= range[1]) {
        currentRange = range.join('-');
        return false;
      }
    });
    return currentRange;
  }
  function getRangeByMonth(departureDateDay, snapshotDate) {
    return snapshotDate.add(departureDateDay, 'days').format('MMMYY');
  }
  function getLowestCabin(cabins) {
    return _.chain(cabins).uniq().orderBy([function (cabin) {
      return _.get(_.find(App.cabinsConfig, {
        cabinCode: cabin
      }), 'cabinIndex', 0);
    }], ['desc']).first().value();
  }
  function getDataBenchmark(snapshotDateData, aggregationMethod) {
    return retrieveData(snapshotDateData).then(_.partial(filter, snapshotDateData)).then(_.partial(aggregate, snapshotDateData.snapshotDate, aggregationMethod)).then(project);
  }
  function getData(snapshotDateData, aggregationMethod) {
    return BenchmarkService.benchmarkPromise('retrieve-fare-change-grid-data', _.partial(getDataBenchmark, snapshotDateData, aggregationMethod));
  }
  return {
    getData: getData
  };
};
FareChangeGridDataProviderService.$inject = ['$q', 'DataRetrieverService', 'DataRetrieverConstantsService', 'FareChangeGridMetricHeatmapService', 'SearchCriteriaRuleFactory', '$filter', 'App', 'BenchmarkService', 'HepService'];
module.exports = FareChangeGridDataProviderService;